import {useEffect, useState} from 'react';
import {Button} from 'semantic-ui-react';
import styles from './scroll-to-top.module.scss';

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollEvent.bind(null, setIsVisible));
    return document.removeEventListener('scroll', handleScrollEvent.bind(null, setIsVisible));
  }, []);

  if (!isVisible) return null;

  return (
    <Button
      circular
      icon='angle up'
      onClick={scrollToTop}
      className={styles['scroll-button']}
    />
  );
}

function handleScrollEvent(setIsVisible) {
  setIsVisible(window.pageYOffset > 300);
}

function scrollToTop() {
  window.scrollTo({top: 0, behavior: 'smooth'});
}

export default ScrollToTop;
